/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
var logger;
export var registerLogger = function registerLogger(_logger) {
  logger = _logger;
};
export default {
  debug: function debug() {
    var _logger2;

    return logger && (_logger2 = logger).debug.apply(_logger2, arguments);
  },
  info: function info() {
    var _logger3;

    return logger && (_logger3 = logger).info.apply(_logger3, arguments);
  },
  warn: function warn() {
    var _logger4;

    return logger && (_logger4 = logger).warn.apply(_logger4, arguments);
  },
  error: function error() {
    var _logger5;

    return logger && (_logger5 = logger).error.apply(_logger5, arguments);
  }
};